import { render } from "./CheckboxList.vue?vue&type=template&id=148c7ed4&scoped=true&ts=true"
import script from "./CheckboxList.vue?vue&type=script&lang=ts"
export * from "./CheckboxList.vue?vue&type=script&lang=ts"

import "./CheckboxList.vue?vue&type=style&index=0&id=148c7ed4&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src602189598/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-148c7ed4"]])

export default __exports__